var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgError404 = function SvgError404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 222,
    viewBox: "0 0 349 222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(-516 -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alien",
    transform: "translate(625.211 245.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M27.482,32.155a2.248,2.248,0,0,1-2.248-2.248c0-12.4-8.069-22.482-17.985-22.482a2.248,2.248,0,1,1,0-4.5c12.4,0,22.482,12.1,22.482,26.978A2.248,2.248,0,0,1,27.482,32.155Z",
    transform: "translate(6.241 1.567)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M44.248,26.553A2.248,2.248,0,0,1,42,24.3C42,11.823,49.754,4.071,62.234,4.071a2.248,2.248,0,0,1,0,4.5C52.234,8.567,46.5,14.3,46.5,24.3A2.248,2.248,0,0,1,44.248,26.553Z",
    transform: "translate(52.423 2.993)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M60.675,117.2c25.283.351,39.388-9.849,47.23-20.658,8.1-11.164,10.71-25.366,8.2-38.945-9.089-49.114-55.429-48.7-55.429-48.7s-46.337-.416-55.427,48.7c-2.513,13.579.1,27.778,8.2,38.945C21.287,107.344,35.392,117.546,60.675,117.2Z",
    transform: "translate(5.404 9.013)",
    fill: "#81ccb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M10.115,33.049A5.111,5.111,0,0,0,6.61,31.5C2.959,31.5,0,35.959,0,41.451S2.959,51.4,6.607,51.4a5.4,5.4,0,0,0,4.071-2.167A53.136,53.136,0,0,1,10.115,33.049Z",
    transform: "translate(0 37.235)",
    fill: "#14a085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M64.194,32.954c-1.266-5.344-5.171-8.99-8.721-8.143a4.972,4.972,0,0,0-2.754,1.922A72.706,72.706,0,0,1,55.7,37.877a55.094,55.094,0,0,1,.737,5.67,5.047,5.047,0,0,0,3.615.616C63.607,43.318,65.459,38.3,64.194,32.954Z",
    transform: "translate(65.803 28.727)",
    fill: "#14a085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 13.758,
    cy: 13.489,
    rx: 13.758,
    ry: 13.489,
    transform: "translate(24.73 49.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 13.758,
    cy: 13.489,
    rx: 13.758,
    ry: 13.489,
    transform: "translate(78.686 49.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 13.758,
    cy: 13.489,
    rx: 13.758,
    ry: 13.489,
    transform: "translate(53.956 25.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 7.013,
    cy: 6.745,
    rx: 7.013,
    ry: 6.745,
    transform: "translate(31.474 56.524)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 7.013,
    cy: 6.745,
    rx: 7.013,
    ry: 6.745,
    transform: "translate(85.431 56.524)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 7.013,
    cy: 6.745,
    rx: 7.013,
    ry: 6.745,
    transform: "translate(60.701 31.794)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M82.545,45.265l-8.993-6.745a2.247,2.247,0,1,0-2.7,3.595l3.17,2.376c-2.862,3.6-12.023,13.894-24.5,15.762C41.635,61.441,33.7,59.008,25.938,53.1l2.653-1.99a2.247,2.247,0,1,0-2.7-3.595L16.9,54.256a2.247,2.247,0,0,0,2.7,3.595l2.646-1.985a2.074,2.074,0,0,0,.214.252c7.518,5.937,15.27,8.928,23.107,8.928a31.31,31.31,0,0,0,4.658-.351C64.5,62.542,74.494,51.2,77.63,47.194l2.219,1.664a2.246,2.246,0,1,0,2.7-3.593Z",
    transform: "translate(19.972 45.431)",
    fill: "#5da892"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 6.5,
    transform: "translate(-0.211 0.381)",
    fill: "#14a085"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 6.745,
    cy: 6.745,
    r: 6.745,
    transform: "translate(114.657 2.567)",
    fill: "#14a085"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(40.789 56.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 2,
    cy: 2.5,
    rx: 2,
    ry: 2.5,
    transform: "translate(69.789 31.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(94.789 56.381)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(565 360)",
    fill: "#fff",
    fontSize: 180,
    fontFamily: "VisbyRoundCF-Regular, Visby Round CF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -48.69,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(816 360)",
    fill: "#fff",
    fontSize: 180,
    fontFamily: "VisbyRoundCF-Regular, Visby Round CF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -48.69,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(765 209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(803 200)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(765 281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(776 336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(750 220)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(798 242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(730 380)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(762 233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(671 239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 608.4, 291.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(700 389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(786 299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(716 231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(807 293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(570 379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(761 257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(759 335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(612 339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(559 378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(779 233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 632.991, 278.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(816 302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(753 354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(783 218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(826 195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 618.152, 292.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(598 384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(711 243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(730 217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(584 258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(718 384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 607.341, 302.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(598 361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(536 394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(0.848, 0.53, -0.53, 0.848, 621.119, 280.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(662 242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(803 219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(708 376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(662 230)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(782 254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(583 307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(638 389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(814 211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(590 324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(546 382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(817 288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(582 278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(645 370)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(555 394)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "fonts/error404.svg";
export { ForwardRef as ReactComponent };